module.exports = __webpack_public_path__ + "img/VanExposure.c26c0d33.jpg";